<template>
  <div class="card-header--actions">
    <b-dropdown
      :id="dropdownId"
      no-caret
      right
      variant="link p-0 btn-link-primary"
      class="text-primary"
      :disabled="disabled"
    >
      <template slot="button-content">
        <div :class="`font-size-${size}`">
          <font-awesome-icon icon="ellipsis-h" size="sm" class="icon__dropdown-menu" />
        </div>
      </template>
      <slot />
    </b-dropdown>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faEllipsisH } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faQuestionCircle, faEllipsisH);

export default {
  name: 'BaseEllipsis',

  components: {
    'font-awesome-icon': FontAwesomeIcon
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    dropdownId: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'xl'
    }
  }
};
</script>

<style lang="scss" scoped></style>
